import React from "react";
import {IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar} from "@ionic/react";
import MqttSceneBuilderComponent from "./components/MqttSceneBuilderComponent";

const MqttSceneOverview: React.FC = () => {
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>Scene's</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                <MqttSceneBuilderComponent />
            </IonContent>
        </IonPage>
    );
}

export default MqttSceneOverview;
